import { render } from "./Youtube.vue?vue&type=template&id=1e35625e"
const script = {}
script.render = render

export default script